import React, { useState, useContext } from 'react'
import { Grid, Box } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import { Formik, Field } from 'formik'
import LiquidSelectAdapter from '@src/components/LiquidSelectAdapter'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '../../messages'
import {
  modificationTypeWithPropertyKeys,
  getALLValue,
} from './ModificationResponse'
import { configContext } from '../../utils/StandardReducer'
import clsx from 'clsx'
import InfoIcon from '@material-ui/icons/Info'
import styles from '@src/routes/Configurators/utils/styles'
import { TubeProperties, CountryType, TubeProduct } from '../../utils/enum'

const INITIAL_VALUES = {
  modificationType: 'default',
  modificationSelect: '',
}

export enum DefaultValue {
  Select = 'Select',
  All = 'ALL',
  internalMod = 'internalMod',
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    inlineModSteps: {
      fontSize: theme.typography.pxToRem(12),
      marginBottom: theme.spacing(5),
      '& ol': {
        paddingLeft: theme.spacing(5),
      },
    },
    fieldLabel: {
      '& label': {
        fontWeight: 'bold',
        fontSize: theme.typography.pxToRem(14),
      },
    },
    AddModificationButton: {
      marginTop: theme.spacing(5),
      width: theme.spacing(50),
      height: theme.spacing(12.5),
    },
    helpText: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightMedium,
      marginLeft: theme.spacing(1),
    },
    helpLink: {
      color: theme.palette.primary.main,
    },
    margin: {
      marginTop: theme.spacing(5),
    },
  }
})
const InlineModifications = (props) => {
  const classes = useStyles()
  const GlobalCSS = styles()
  const { modificationResponseData, productType, productDetails } = props
  const [internalModification, setInternalModification] = useState(
    DefaultValue.All
  )
  const [internalModificationType, setInternalModificationType] = useState(
    DefaultValue.Select
  )
  const { state, dispatch } = useContext(configContext)
  const [modData, setModData] = useState<string>('')
  const intl = useIntl()
  const email = intl.formatMessage(
    messages.PC_SEND_FEASIBLITY_AND_QUOTATION_REQUEST
  )
  const takeModification = (args) => {
    const { value } = args.target
    setInternalModificationType(value)
    setModData(value)
    dispatch({
      type: 'IS_CONFIRM_ORDER',
      data: false,
    })
  }

  React.useEffect(() => {
    if (
      state.errorResponseJson.length !== 0 &&
      internalModificationType !== DefaultValue.Select &&
      !state.errorResponseJson.listInternalMod.includes(
        internalModificationType
      )
    ) {
      setInternalModificationType(DefaultValue.Select)
      setModData('')
    }
    // TODO: need a test before we refactor these dependencies
  }, [state.errorResponseJson])

  const addModification = () => {
    if (
      productType === messages.CONF_PRODUCT_STANDARD.defaultMessage ||
      productType === TubeProduct.iscaledna
    ) {
      dispatch({ type: 'FOCUS_ON_SEQUENCEBOX', data: true })
      dispatch({ type: 'UPDATE_OPTIONAL_BASES', data: modData })
      dispatch({ type: 'OPTIONAL_BASES_CHANGED', data: true })
      setInternalModificationType(DefaultValue.Select)
      setInternalModification(DefaultValue.All)
      setModData('')
      dispatch({ type: 'IS_CONFIRM_ORDER', data: false })
    }
  }

  const handleChange = (event) => {
    setInternalModification(event.target.value)
    setInternalModificationType(DefaultValue.Select)
    dispatch({
      type: 'IS_CONFIRM_ORDER',
      data: false,
    })
  }

  return (
    <>
      <div
        className={clsx(classes.inlineModSteps, GlobalCSS.globalHelpTextColor)}
      >
        <Box component="p">
          {<FormattedMessage {...messages.CONF_INLINE_MOD_STEPS_standard} />}
        </Box>
        <ol>
          <li>
            {<FormattedMessage {...messages.CONF_INLINE_MOD_STEP_1_standard} />}
          </li>
          <li>
            {<FormattedMessage {...messages.CONF_INLINE_MOD_STEP_2_standard} />}{' '}
          </li>
          <li>
            {<FormattedMessage {...messages.CONF_INLINE_MOD_STEP_3_standard} />}{' '}
            <span>
              {<FormattedMessage {...messages.CONF_ADD_MODIFICATION} />}
            </span>{' '}
            {
              <FormattedMessage
                {...messages.CONF_INLINE_MOD_STEP_3B_standard}
              />
            }
          </li>
        </ol>
      </div>
      <Formik
        initialValues={INITIAL_VALUES}
        onSubmit={(values, actions) => {
          setTimeout(() => {
            actions.setSubmitting(false)
          }, 1000)
        }}
      >
        {() => (
          <>
            <Grid container spacing={10}>
              {productType === TubeProduct.iscaledna ? (
                <Grid item xs={12} sm={4} className={classes.fieldLabel}>
                  <Field
                    name="modificationSelect"
                    component={LiquidSelectAdapter}
                    value={internalModificationType}
                    onChange={(e) => takeModification(e)}
                    options={[
                      {
                        label: DefaultValue.Select,
                        value: DefaultValue.Select,
                      },

                      ...getALLValue(
                        DefaultValue.internalMod,
                        internalModification,
                        modificationResponseData,
                        state.errorResponseJson,
                        state.sessionData[state.currentOligoIndex].isOverridden
                      ),
                    ]}
                    label=" "
                    filled
                  />
                </Grid>
              ) : (
                <>
                  <Grid item xs={12} sm={4} className={classes.fieldLabel}>
                    <Field
                      name="modificationType"
                      component={LiquidSelectAdapter}
                      label={
                        <FormattedMessage
                          {...messages.CONF_INTERNAL_MOD_TYPE_standard}
                        />
                      }
                      value={internalModification}
                      onChange={(e) => handleChange(e)}
                      options={[
                        {
                          label: DefaultValue.All,
                          value: DefaultValue.All,
                        },
                        ...modificationTypeWithPropertyKeys(
                          DefaultValue.internalMod,
                          modificationResponseData
                        ),
                      ]}
                      filled
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} className={classes.fieldLabel}>
                    <Field
                      name="modificationSelect"
                      component={LiquidSelectAdapter}
                      value={internalModificationType}
                      onChange={(e) => takeModification(e)}
                      options={[
                        {
                          label: DefaultValue.Select,
                          value: DefaultValue.Select,
                        },

                        ...getALLValue(
                          DefaultValue.internalMod,
                          internalModification,
                          modificationResponseData,
                          state.errorResponseJson,
                          state.sessionData[state.currentOligoIndex]
                            .isOverridden
                        ),
                      ]}
                      label={
                        <FormattedMessage
                          {...messages.CONF_INTERNAL_MOD_standard}
                        />
                      }
                      filled
                    />
                  </Grid>
                </>
              )}
            </Grid>
            <Button
              color="primary"
              variant="contained"
              className={classes.AddModificationButton}
              onClick={addModification}
            >
              <FormattedMessage {...messages.CONF_ADD_MODIFICATION} />
            </Button>
            <div className={classes.margin}>
              <Grid container className={GlobalCSS.noteInfo}>
                <Grid item xs={1} className={GlobalCSS.InfoText}>
                  <InfoIcon
                    aria-label="info"
                    className={GlobalCSS.InfoIcon}
                    color="primary"
                  ></InfoIcon>
                </Grid>
                <Grid item xs={11}>
                  <FormattedMessage
                    {...messages.PC_SEND_FEASIBLITY_AND_QUOTATION_MSG}
                  />
                  {productDetails.countryCode !== CountryType.cpeptideJapan ? (
                    <a href={`mailto:${email}`}>
                      <span
                        className={clsx(classes.helpText, classes.helpLink)}
                      >
                        <FormattedMessage
                          {...messages.PC_SEND_FEASIBLITY_AND_QUOTATION_REQUEST}
                        />
                      </span>
                    </a>
                  ) : (
                    <a href={`mailto:${TubeProperties.cpeptideJPEmail}`}>
                      <span
                        className={clsx(classes.helpText, classes.helpLink)}
                      >
                        <FormattedMessage
                          {...messages.PC_CONTACT_JP_CPEPTIDE}
                        />
                      </span>
                    </a>
                  )}
                </Grid>
              </Grid>
            </div>
          </>
        )}
      </Formik>
    </>
  )
}

export default InlineModifications
